const ClusterSettingConstants = {
  CCPA_REDIRECT_URL: 'node.ccpaRedirectUrl', // HPWEB-5505
};

export default ClusterSettingConstants;
